import React from "react";
import Page from "./page";

function Index() {
	return (
			<Page />
	);
}

export default Index;